import { reactive, type App } from 'vue'
import type { SevenIgamingPlatformConfig } from './interfaces/sevenIgamingPlatform'
import bettingAcceptanceApiClient from './services/bettingAcceptanceApiClient'
import cmsApiClient from './services/cmsApiClient'
import vouchersApiClient from './services/vouchersApiClient'
import directDepositsApiClient from './services/directDepositsApiClient'
import cashRegisterApiClient from './services/cashRegisterApiClient'
import type { AxiosInstance, InternalAxiosRequestConfig } from 'axios'

export const SevenIgamingPlatformKey = Symbol('SevenIgamingPlatformConfig')

const defaultConfig: SevenIgamingPlatformConfig = {
  token: null,
  notificationService: {
    events: []
  },
  language: null,
  slipsStorageDriver: null
}

export const pluginState = reactive<SevenIgamingPlatformConfig>(defaultConfig)

const apiClients = [
  bettingAcceptanceApiClient,
  cmsApiClient,
  vouchersApiClient,
  directDepositsApiClient,
  cashRegisterApiClient
]

export default {
  install(app: App, options?: Partial<SevenIgamingPlatformConfig>) {
    const setAuthToken = (apiClient: AxiosInstance) => {
      apiClient.interceptors.request.use((config: InternalAxiosRequestConfig) => {
        if (pluginState?.token) {
          config.headers['Authorization'] = `Bearer ${pluginState.token}`
        }

        return config
      })
    }

    // Merge provided options with default config
    if (options) {
      Object.assign(pluginState, options)
    }

    // Provide the reactive state to the application
    app.provide(SevenIgamingPlatformKey, pluginState)

    apiClients.forEach(setAuthToken)
  }
}
